module.exports = __webpack_public_path__ + "assets/pdf/handbook-en-webversion-opt.7c4d88b1.pdf";